import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { AuthContextProvider } from "./context/AuthContext";
import { customHistory } from "./history"; // import your custom history

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <HistoryRouter history={customHistory}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </HistoryRouter>
  </AuthContextProvider>
);

reportWebVitals();
